import { PRODUCTS_PER_PAGE } from '@/framework/client/variables';
import { Grid } from '@/components/products/grid';
import { Product } from '@/types';
import type { HomeListContext } from '@/lib/gtm';

interface Props {
  className?: string;
  column?: any;
  gridClassName?: string;
  isLastPage?: boolean;
  showMore?: () => void;
  items?: Product[];
  isLoading?: boolean;
  items_per_page?: number;
  listContext?: HomeListContext;
}

export default function ProductsGrid({
  isLastPage,
  showMore,
  items,
  isLoading,
  className,
  column,
  gridClassName,
  items_per_page,
  listContext,
}: Readonly<Props>) {
  return (
    <Grid
      products={items as unknown as Product[] | undefined}
      loadMore={showMore}
      isLoading={isLoading}
      isLoadingMore={isLoading}
      hasMore={!isLastPage}
      error={null}
      limit={items_per_page || PRODUCTS_PER_PAGE}
      className={className}
      gridClassName={gridClassName}
      column={column}
      listContext={listContext}
    />
  );
}
